/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TimePointRepresentationFromJSON, TimePointRepresentationToJSON, } from './';
export function YearTimePointRepresentationFromJSON(json) {
    return YearTimePointRepresentationFromJSONTyped(json, false);
}
export function YearTimePointRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        timePoints: json['timePoints'].map(TimePointRepresentationFromJSON),
    };
}
export function YearTimePointRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        timePoints: value.timePoints.map(TimePointRepresentationToJSON),
    };
}
